import { getHotelCenterShared } from '@bingads-webui-campaign/hotel-center-shared';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { schemaVnextArray } from '@bingads-webui/hotel-odata-schemas';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center-shared');
const pageContext = globalContext.require('PageContext');
const state = globalContext.require('component/state/index');
const dateFilterPreferences = globalContext.require('component/bingads-grid/service/date-filter-preferences');
const segmentationPreferences = globalContext.require('component/bingads-grid/service/segmentation-preferences');
const preferencesService = globalContext.require('component/preference/service/index');
const CustomerIdType = globalContext.requireDefault('component/edm-campaign/customeridtype');
const config = globalContext.require('component/config/index');

export const {
  dateFilterPlugin,
  fetchPreferenceConfig,
  instrumentation,
  toolbarTemplate,
  jsdataBhc,
} = getHotelCenterShared({
  i18n,
  pageContext,
  state,
  dateFilterPreferences,
  preferencesService,
  segmentationPreferences,
  config,
  schemas: schemaVnextArray,
  CustomerIdType,
});
